import React, { FC, useState } from "react";
import classNames from "classnames";
import { Category, ShopWithCountry } from "../get-parcels-table/components";
import { Checkbox, ShowWhen } from "@/components/common";
import { InfoCircleIcon } from "@/components/assets/icons";

import PaymentTaxDetails from "./payment-tax-details";
import { IShipment } from "@/types/apiResponse.types";
import { useTheme } from "@/context/Theme.context";
import { Theme } from "@/enums";
import { useTranslations } from "next-intl";
import { formatNumber } from "@/utils/formatNumber";

type Props = {
  selectedIds: number[];
  item: IShipment;
  handleSelect: (id: number) => void;
};

const PaymentTableRow: FC<Props> = ({ selectedIds, item, handleSelect }) => {
  const [isOpenedDetails, setIsOpenedDetails] = useState(false);
  const t = useTranslations();
  const theme = useTheme();

  let priceField = item?.priceNational ? "priceNational" : "priceUsd";

  if (theme === Theme.UK) {
    priceField = "priceUsd";
  }

  return (
    <div
      className={classNames(
        "mb-[10px] flex items-center justify-between gap-4 border-2 border-transparent py-[18px]",
        {
          "!rounded-[10px] !border-[#b9dbb7]": selectedIds.includes(
            item?.shipmentId,
          ),
        },
      )}
    >
      <div className="w-[80px] border-r pl-[20px]">
        <Checkbox
          name="selectedItem"
          checked={selectedIds.includes(item?.shipmentId)}
          onChange={() => handleSelect(item?.shipmentId)}
        />
      </div>
      <div className="w-[40px]">
        <ShopWithCountry shop={item?.onlineShop} country={item?.countryId} />
      </div>
      <div className="w-[300px]">
        <span>{item.trCode}</span>
      </div>
      <div className="w-[70px]">
        <Category category={item?.shipmentTypeId} />
      </div>
      <div
        className="relative flex items-center gap-2"
        onMouseEnter={() => setIsOpenedDetails(true)}
        onMouseLeave={() => setIsOpenedDetails(false)}
      >
        <div className="flex w-[150px] cursor-pointer items-center justify-center gap-2">
          <span>
            {theme === Theme.UZ
              ? t("uzs")
              : theme === Theme.GEORGIA
                ? "₾"
                : "$"}
            {formatNumber(item[priceField] || 0)}
          </span>{" "}
          <InfoCircleIcon />
        </div>
        <ShowWhen condition={isOpenedDetails}>
          <PaymentTaxDetails item={item} />
        </ShowWhen>
      </div>
    </div>
  );
};

export default PaymentTableRow;
